export enum CATEGORY {
    NAVIGATION = 'NAVIGATION',
    CHARTS = 'CHARTS',
    THREAT = 'THREAT',
    AMDB = 'AMDB',
    EPIC_TERRAIN = 'EPIC / APEX TERRAIN',
    PEAF_TERRAIN = 'PEAF TERRAIN',
}
export enum SUBSCRIPTION_STATUS {
    MODIFIED = 'MODIFIED',
    ADD_PART_2 = 'ADD_PART_2',
    EXCEPTION = 'EXCEPTION',
    ACTIVE = 'ACTIVE',
    EXPIRED = 'EXPIRED',
}